import { render, staticRenderFns } from "./review-action-complain.vue?vue&type=template&id=5e428eb9"
import script from "./review-action-complain.vue?vue&type=script&lang=ts"
export * from "./review-action-complain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports